// eslint-disable-next-line @nx/enforce-module-boundaries
import { TeamsPage } from '@insurance/features/staff/pages'
import { useParams } from 'react-router-dom'

export const TeamsStaffPage = () => {
  const { id } = useParams()

  if (!id) return null

  return <TeamsPage brokerId={id} />
}
